// 客户列表
const ValidCustomer = () => import('@/pages/customer/valid-customer.vue');

// 医生客户
const medicalCusVaild = () => import('@/pages/customer/valid-medicalCus.vue');

// 机构驳回客户
const RefusedCustomer = () => import('@/pages/customer/refused-customer.vue');

// 申请中客户列表
const UnauditedCustomer = () =>
  import('@/pages/customer/unaudited-customer.vue');

// 政府客户列表
const GovernmentCustomer = () =>
  import('@/pages/customer-government/index.vue');

// 医生列表
const crmdoctorlist = () => import('@/pages/customer/crmdoctor-list.vue');

const arr = [
  // 客户列表
  {
    path: '/customer/valid',
    name: 'customerValid',
    component: ValidCustomer,
    meta: {
      auth: false,
    },
  },
  // 医生客户
  {
    path: '/medicalCus/vaild',
    name: 'medicalCusVaild',
    component: medicalCusVaild,
    meta: {
      auth: false,
    },
  },
  {
    path: '/customer/refused',
    name: 'customerRefused',
    component: RefusedCustomer,
    meta: {
      auth: false,
    },
  },
  // 申请中客户列表
  {
    path: '/customer/appling',
    name: 'customerUnaudited',
    component: UnauditedCustomer,
    meta: {
      auth: false,
    },
  },
  // 政府客户
  {
    path: '/customer/government',
    name: 'governmentCustom',
    component: GovernmentCustomer,
    meta: {
      auth: false,
    },
  },
  // 医生列表
  {
    path: '/customer/doctorlist',
    name: 'doctorlist',
    component: crmdoctorlist,
    meta: {
      auth: false,
    },
  },
];

export default arr;
